import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
// Reown Metrics and analytics is switched off
(window as any).ClientAnalytics = {
  init: () => {},
  identify: () => {},
  PlatformName: { web: 'web' }
};
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
